import API from '@/services/typings'
import request, { METHODS } from '@/api'
import UrlConfig, { getEnumURL } from '@/api/UrlConfigs.ts'

/**
 * 获取授权列表
 * @param options axios配置参数
 */
export const getEmpowerBatchAuthList = (options?: API.Options) =>
  request(UrlConfig.Base.GetEmpowerBatchAuthList, {
    method: METHODS.GET,
    ...options,
  })

// SaaS 获取数据字典
export const dataDictionary = data => {
  return request(`/caas-web/dataDictionary/tree`, { method: METHODS.POST, data })
}

/**
 * 通过员工号获取加密随机字符
 * @param {object} params - Url参数  ?username=xxx
 */
export const httpGetPswKey = (options?: API.Options) =>
  request(UrlConfig.Portal.HttpGetPswKey, {
    method: METHODS.POST,
    ...options,
  })

/**
 * 登录接口
 * @param {object} params - Url参数  ?username=xxx&password=md5(`${password}${salt}`)
 */
export const httpLogin = (options?: API.Options) =>
  request(UrlConfig.Portal.HttpLogin, {
    method: METHODS.POST,
    ...options,
  })

// 根据工号获取呼叫中心坐席
export const getSeatAccountByWorkNumber = workNumber => {
  return request(`${UrlConfig.Clue.GetSeatAccountByWorkNumber}${workNumber}`, {
    method: METHODS.GET,
  })
}

/**
 * 返回用户信息
 *
 */
export const fetchUnifiedProfile = (options?: API.Options) =>
  request(UrlConfig.Portal.FetchUnifiedProfile, {
    method: METHODS.POST,
    ...options,
  })

/**
 * 获取文件前缀
 */
export const getFileUrlPrefix = () => {
  return request(
    // '/api-crm/file/getFileUrlPrefix',
    UrlConfig.File.FetchUnifiedProfile,
    {
      method: METHODS.GET,
      error: false,
    }
  )
    .then((res: any) => res.prefix)
    .catch(err => err)
}

export const X_TRANSFER_KEY = 'X-Transfer-Inside-Tenant-Id'

/** 获取租户配置 **/
export const getPlatformWebConfig = () => {
  return request(UrlConfig.Platform.GetPlatformWebConfig, {
    method: METHODS.GET,
    params: {
      domain: window.location.hostname,
      // domain: 'shj-saas-stage.shjmall.cn',
    }, //window.location.hostname lr-saas.shjmall.cn
  }).then((res: any) => {
    // const { tenantId } = res || {}
    // if (tenantId) {
    //   localStorage.setItem(X_TRANSFER_KEY, tenantId)
    // }
    return res
  })
}

/** 获取登录参数 - 企微二维码参数、..**/
export const getLoginParams = () => {
  return request(UrlConfig.Caas.getLoginParams, {
    method: METHODS.GET,
    // params: {
    //   domain: window.location.hostname,
    //   // domain: 'shj-saas-stage.shjmall.cn',
    // }, //window.location.hostname lr-saas.shjmall.cn
    error: false,
    headers: { Authorization: false },
    signal: new AbortController().signal
  })
}

export const saasLogin = data => {
  return request(UrlConfig.Caas.SaasLogin, {
    method: METHODS.POST,
    data,
    timeout: 60000 * 60,
  })
}

//
export const saasQrCodeLogin = (code, agentId) => {
  return request(
    // UrlConfig.Caas.SaasQrCodeLogin.replace('{agentId}', agentId),
    UrlConfig.Caas.SaasQrCodeLogin,
    {
      method: METHODS.GET,
      params: { code },
      timeout: 60000 * 60,
    }
  )
}

export const saasProfile = () => {
  return request(UrlConfig.Caas.SaasProfile, {
    method: METHODS.GET,
    // raw: true,
  })
}

export const platformLogin = params => {
  return request(UrlConfig.Platform.PlatformLogin, {
    method: METHODS.POST,
    data: params,
  })
}

// 重置密码 - 发送验证码
export const sendVerificationCode = data => {
  return request(UrlConfig.Caas.SendVerificationCode, {
    method: METHODS.POST,
    data,
  })
}

// 重置密码
export const foundPassword = data => {
  return request(UrlConfig.Caas.FoundPassword, {
    method: METHODS.POST,
    data,
    raw: true,
  })
}

// 获取用户权限
export const getCurrentResources = () => {
  return request(
    // saasPrefix + '/caas-web/resources/current',
    UrlConfig.Caas.GetCurrentResources,
    {
      method: METHODS.GET,
    }
  )
}

// 获取参数配置项
export const GetGeneralParamConfField = () => {
  return request(
    // saasPrefix + '/caas-web/resources/current',
    UrlConfig.Caas.GetGeneralParamConfField,
    {
      data: {
        paramKeys: ['TENANT_PATTEN_TYPE'],
      },
      method: METHODS.POST,
      error: false,
    }
  )
}

// 刷新token
export const refreshTokenApi = refreshToken => {
  return request(UrlConfig.Caas.RefreshTokenApi, {
    params: { refreshToken: refreshToken },
    method: METHODS.GET,
  })
}

// 切换职位
export const changePosition = deptPostId => {
  return request(UrlConfig.Caas.ChangePosition + `${deptPostId}`, {
    method: METHODS.POST,
  })
}

// 切换职位
export const updatePassword = data => {
  return request(UrlConfig.Caas.UpdatePassword, {
    method: METHODS.POST,
    data,
    raw: true,
  })
}

/**
 * 查询下载中心分页列表
 * @param options
 */
export const downloadPage = (options?: API.Options) =>
  request(UrlConfig.Export.DownloadPage, {
    method: METHODS.POST,
    ...options,
  })

// 查询下载中心 状态枚举
export const getExportTaskStatus = (path: string) => {
  return request(getEnumURL('plus-export', path), {
    method: METHODS.GET,
  })
}

/**
 * 根据Id删除数据
 * @param id
 * @param options
 */
export const deleteExportTask = (id, options?: API.Options) =>
  request(`${UrlConfig.Export.DeleteExportTask}${id}`, {
    method: METHODS.DELETE,
    ...options,
  })

/**
 * 重试
 * @param id
 * @param options
 */
export const asyncImportExportTaskRetry = (id, options?: API.Options) =>
  request(`${UrlConfig.Export.AsyncImportExportTaskRetry}${id}`, {
    method: METHODS.GET,
    ...options,
  })

/**
 * 编辑数据
 * @param options
 */
export const asyncImportExportTaskUpdateById = (options?: API.Options) =>
  request(UrlConfig.Export.AsyncImportExportTaskUpdateById, {
    method: METHODS.POST,
    ...options,
  })

/**
 * 公司list
 */
export const getCompanyList = () => {
  return request(UrlConfig.Caas.GetCompanyList, {
    method: METHODS.GET,
    data: { enabled: true },
  })
    .then(res => res || [])
    .catch(() => [])
}

/**
 * 流程快捷方式 list
 */
export const getUCenterFlowShortcutsList = () => {
  return request(UrlConfig.Caas.GetUCenterFlowShortcutsList, {
    method: METHODS.POST,
    data: {},
  })
    .then(res => res || [])
    .catch(() => [])
}

export const getTenantList = (data = {}) => {
  return request(UrlConfig.Caas.GetTenantList, {
    method: METHODS.POST,
    data,
  })
}

export const changeTenant = tenantId => {
  return request(UrlConfig.Caas.ChangeTenant + tenantId, {
    method: METHODS.POST,
  })
}

// 个人中心

export const getUCenterInfo = userId => {
  return request(UrlConfig.Caas.GetUCenterInfo, {
    method: METHODS.GET,
    params: { userId },
  })
}
export const uCenterUpdateName = (data = {}) => {
  return request(UrlConfig.Caas.UCenterUpdateName, {
    method: METHODS.POST,
    data,
  })
}

export const uCenterVerifyPhoneCode = (data = {}) => {
  return request(UrlConfig.Caas.UCenterVerifyPhoneCode, {
    method: METHODS.POST,
    data,
  })
}

export const uCenterUpdatePhone = (data = {}) => {
  return request(UrlConfig.Caas.UCenterUpdatePhone, {
    method: METHODS.POST,
    data,
  })
}

export const uCenterSendPhoneCode = (data = {}) => {
  return request(UrlConfig.Caas.UCenterSendPhoneCode, {
    method: METHODS.POST,
    data,
  })
}
export const sendPhoneCodeNonAuth = (data = {}) => {
  return request(UrlConfig.Caas.UCenterSendPhoneCodeNonAuth, {
    method: METHODS.POST,
    data,
  })
}

export const uCenterUpdatePassword = (data = {}) => {
  return request(UrlConfig.Caas.UCenterUpdatePassword, {
    method: METHODS.POST,
    data,
  })
}

export const updatePasswordByPhoneValidate = (data = {}) => {
  return request(UrlConfig.Caas.updatePasswordByPhoneValidate, {
    method: METHODS.POST,
    data,
  })
}

export const controlPanelSendUpdatePhoneCode = (data = {}) => {
  return request(UrlConfig.Caas.ControlPanel_sendUpdatePhoneCode, {
    method: METHODS.POST,
    data,
  })
}

export const controlPanelUpdatePhone = (data = {}) => {
  return request(UrlConfig.Caas.ControlPanel_updatePhone, {
    method: METHODS.POST,
    data,
  })
}

export const controlPanelSendUpdateMailCode = (data = {}) => {
  return request(UrlConfig.Caas.ControlPanel_sendUpdateMailCode, {
    method: METHODS.POST,
    data,
  })
}

export const controlPanelUpdateMail = (data = {}) => {
  return request(UrlConfig.Caas.ControlPanel_updateMail, {
    method: METHODS.POST,
    data,
  })
}

export const uCenterUpdateAvatar = (data = {}) => {
  return request(UrlConfig.Caas.UCenterUpdateAvatar, {
    method: METHODS.POST,
    data,
  })
}

// 管理员设置

// export const getOrgTree = (data={}) => {
//   return request(UrlConfig.Caas.GetOrgTree, {
//   method: METHODS.POST,
//   data,
//   })
// }

// 应用
export const getUCenterAppTypeList = () => {
  return request(UrlConfig.Caas.GetUCenterAppTypeList, {
    method: METHODS.GET,
  })
}
export const getUCenterAppList = (data = {}) => {
  return request(UrlConfig.Caas.GetUCenterAppList, {
    method: METHODS.POST,
    data: { appUseTypes: ['WEB', 'BOTH'], ...data },
  })
}

export const GetUCenterAopMarketList = (data = {}) => {
  return request(UrlConfig.Caas.GetUCenterAopMarketList, {
    method: METHODS.POST,
    data,
  })
}

export const getUCenterApp = id => {
  return request(UrlConfig.Caas.GetUCenterApp + id, {
    method: METHODS.GET,
  })
}
export const getUCenterAppDetailByCode = code => {
  return request(UrlConfig.Caas.GetUCenterAppDetail + code, {
    method: METHODS.GET,
  })
}
export const tenantAppCollect = (appCode, type, data?) => {
  return request(`${UrlConfig.Caas.AppCollect}/${appCode}/${type}`, {
    method: METHODS.POST,
    data,
  })
}

export const tenantAppCollectRemove = (appCode, type, data?) => {
  return request(`${UrlConfig.Caas.AppCollectRemove}/${appCode}/${type}`, {
    method: METHODS.POST,
    data,
  })
}

export const tenantAppCollectList = (type, data?) => {
  return request(`${UrlConfig.Caas.AppCollectList}/${type}`, {
    method: METHODS.GET,
    data,
  })
}

export const exportDownCount = () => {
  return request(`${UrlConfig.Export.ExportDownCount}`, {
    method: METHODS.GET,
    error: false,
  })
}

/**
 * 供应商制度
 */
export const vendorRuleUnReadPage = async (
  current: number | string,
  pageSize: number | string,
  data: any = {}
) => {
  const resp = await request(
    UrlConfig.Vms.VendorRuleUnReadPage + `?current=${current}&pageSize=${pageSize}`,
    {
      method: METHODS.POST,
      data,
    }
  )
  return resp
}
/**
 * 供应商制度已读
 */
export const vendorRuleViewTimes = async (data: any = {}) => {
  const resp = await request(UrlConfig.Vms.VendorRuleViewTimes, {
    method: METHODS.POST,
    data,
  })
  return resp
}

/**
 * 显示加密 电话 身份证等
 */
export const showRequest = (url = UrlConfig.PlusCrmWeb.ViewPhone, Type = 'GET', params) =>
  request(url, {
    params,
    method: METHODS[Type],
  })
/*
 *  根据门店编码-查询部门
 * */
export const getQueryDeptListt = params => {
  return request(UrlConfig.Caas.GetQueryDeptListt, {
    method: METHODS.POST,
    params,
  })
}

/*
 * 获取银行
 * */
export const getBanksList = async (data: any) => {
  const resp: any = await request(UrlConfig.Platform.GetBanksList + '?pageId=1&pageSize=1000', {
    method: METHODS.POST,
    data: data,
  })
  return resp?.list || []
}
/*
 * 获取地区
 * */
export const getBanksAreasList = async (data: any) => {
  const resp: any = await request(
    UrlConfig.Platform.GetBanksAreasList + '?pageId=1&pageSize=1000',
    {
      method: METHODS.POST,
      data: data,
    }
  )
  return resp?.list || []
}
/*
 * 获取支行名称
 * */
export const getBanksLocationsList = async (data: any) => {
  const resp: any = await request(
    UrlConfig.Platform.GetBanksLocationsList + '?pageId=1&pageSize=1000',
    {
      method: METHODS.POST,
      data: data,
    }
  )
  return resp?.list || []
}
/*
 * 获取支行名称
 * */
export const searchBankBranch = async (data: any) => {
  const resp: any = await request(
    UrlConfig.EsWeb.SearchBankBranch + '?page=1&size=100',
    {
      method: METHODS.POST,
      data: data,
    }
  )
  return resp?.list || []
}
/*
 * 获取门店
 * */
export const fetchAllList = (companyType, query?: any) => {
  return request(UrlConfig.Caas.GetCompanyBranchList, {
    method: METHODS.POST,
    data: {
      enabled: true,
      companyType,
      ...query,
      orgType: 'COMPANY',
    },
  })
}
/*
 * 获取门店 - 根据当前人过滤后
 * */
export const GetUserCompanys = (query?: any) => {
  return request(UrlConfig.Deal.GetUserCompanys, {
    method: METHODS.GET,
  })
}
/**
 * 获取枚举
 */
export const getEnumTamsList = (path: string) => {
  return request(`${UrlConfig.plusPmWeb.GetQvEnumTamsAll}/${path}`, {
    method: METHODS.GET,
  })
    .then(resp => {
      return resp || []
    })
    .catch(() => [])
}
/**
 * 获取承包商信息
 */
export const getVendorInfo = data => {
  return request(`${UrlConfig.plusPmWeb.VendorInfoSelectByVoderCode}`, {
    method: METHODS.POST,
    data,
  })
}

//
/**
 * 承包商列表
 */
export const fetchVendorInfoList = () => {
  return request(UrlConfig.plusPmWeb.vendorInfoList, {
    method: METHODS.POST,
    data: {
      name: '',
    },
  })
}
/**
 * 获取技能标签列表
 *
 */
export const getWorkTypeList = (status: any = '') => {
  return TagsCategory({ code: 'DELIVERY_SKILL', status: true }).then((response: any) => {
    return new Promise(async resolve => {
      const resData: any = await request(UrlConfig.Caas.TagsSearch, {
        method: METHODS.POST,
        data: {
          tagCategoryId: response[0].id,
          status,
        },
      })
      resolve(resData)
    })
  })
}
/**
 * 获取技能标签列表
 *
 */
export const TagsCategory = (data?: {}) => {
  return new Promise(async resolve => {
    const resData: any = await request(UrlConfig.Caas.TagsCategory, {
      method: METHODS.POST,
      data: {
        ...data,
      },
    })
    resolve(resData)
  })
}

// 文件上传
export const uploadFile = (data: any) => {
  return request(UrlConfig.File.UploadFile, {
    method: METHODS.POST,
    data: data,
  }).then((res: any) => {
    return res
  })
}
/**
 * 获取数据字典-和另一个业务字典接口不同
 * @param params 参数  { key: 'productionType', enable: '1' }
 * @returns
 */
export const httpDictServ = (
  data: { parentKey: string; enable: string | number } | { [key: string]: any }
) => {
  return new Promise(async resolve => {
    const resData: any = await request(UrlConfig.Platform.DataDictionary, {
      method: METHODS.POST,
      data,
    })
    resolve(resData.list || [])
  })
}

export const httpDictServList = (
  data: { parentKey: string; enable: string | number } | { [key: string]: any }
) => {
  return new Promise(async resolve => {
    const resData: any = await request(UrlConfig.Platform.DataDictionaryList, {
      method: METHODS.POST,
      data,
    })
    resolve(resData || [])
  })
}

/*
 *  获取打印模板
 * */
export const getPrintTemplateList = (data: any = {}) => {
  return request(UrlConfig.PlusGoodsWeb.GetPrintTemplateList, {
    method: METHODS.POST,
    data: { queryFields: ['id', 'name'], ...data },
  })
}

// 批量获取字典数据
export const getChildrenDicts = keys => {
  return request(UrlConfig.PlusProductWeb.GetDataDictionaryChildren, {
    method: METHODS.POST,
    data: [...keys],
  })
}
